import React, { useEffect, useState } from "react";
import { fetchData } from "../Components/common/utils";
import { NavLink } from "react-router-dom";
const OurServices = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/service";
            const result = await fetchData(url);
            if (result) {
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, []);

    return (
        <>
            {/* <section class="page-top-section text-center">
                <div class="container">
                    <div class="page-header">
                        <h1>Our Services</h1>
                    </div>
                </div>
            </section> */}
            <div className="container mt-4">
                {/* Modern Header */}
                <div className="brand-banner py-3 px-3 text-center text-white mb-4">
                    <h1 className="display-4 fw-bold mb-2">Our  <span className="brand-name">Services</span></h1>
                    <p className="lead">Explore our trusted services, connect with experts, and choose the perfect solution for your needs.</p>
                </div>
            </div>
            <section className=" pb-5">
                <div className="container">
                    {loading && (
                        <div
                            style={{ height: "30em" }}
                            className="mt-5 d-flex justify-content-center align-items-center"
                        >
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>)}
                    <div className="row mt-5">
                        {data.slice(0, 5).map((details, index) => (
                            <div className="col-md-6 " key={index} >
                                <NavLink to={`/our-services/${details.slug}`}>
                                    <div className="our-services-page text-black d-flex align-items-center">
                                        {details.media.length > 0 ? (
                                            <img
                                                src={details.media[0].original_url}
                                                alt={details.name}
                                            />
                                        ) : (
                                            <div className="spinner-border theme-clr" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        )}
                                        <div>
                                            <h4 className="mb-2">{details.title}</h4>
                                            <p className="product-card-description">{details.description}</p>
                                        </div>
                                    </div>
                                </NavLink>

                            </div>
                        ))}

                    </div>

                </div>
            </section>
        </>
    );
};

export default OurServices;
